<style scoped="scoped" lang="scss">
.detail-container {
  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .title-blue {
    color: #409eff;
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.el-dialog__footer {
  padding: 10px;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/mould/listByPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujubianhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianhao(jingzhun)')">
            <el-input v-model="yt.conditions.noEqual"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jimopeichanpin')">
            <!-- 跨组件 - 物料信息 -->
            <yi_cross_select multiple :component="'web_base_matter_list'" :min="1" :ids.sync="yt.conditions.products"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('jimopeijitai')">
            <!-- 跨组件 - 设备信息 -->
            <yi_cross_select :component="'web_base_equipment_list'" multiple :min="1" :ids.sync="yt.conditions.equipmentIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('jimopeidunwei')">
            <!-- <yi_number_input :type="'number'" :start.sync="yt.conditions.tonnage"></yi_number_input> -->
            <el-input-number v-model="yt.conditions.tonnage" controls-position="right" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('xiangmuhao')">
            <el-input v-model="yt.conditions.projectNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujuweizhi')">
            <el-input v-model="yt.conditions.location"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouchanqianbaoyang')">
            <el-select v-model="yt.conditions.isPrepareMaintain">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_base_mould_create')"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('web_base_mould_batch_create')" @click="show = !show" plain>
          {{ $t('daorumujutaizhang') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('basic_mouldEquipment_batch_create')" @click="productionShow = !productionShow" plain>
          {{ $t('daorumujuchanpinguanxi') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('basic_mould_adpterEquipment_batch_create')" @click="equipmentShow = !equipmentShow" plain>
          {{ $t('daorumujushebeiguanxi') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('basic_mould_tonnage_batch_update')" @click="tonnageShow = !tonnageShow" plain>
          {{ $t('daorumujushebeidunweiguanxi') }}
        </el-button>

        <el-button size="mini" v-if="utils.checkPower('web_base_mould_mouldEquipment_batch_create_by_match_number')" @click="mainSubProductShow = !mainSubProductShow" plain>
          {{ $t('daoruzhufuchanpin') }}
        </el-button>
        <el-button size="mini" @click="exportExcel2()">
          {{ $t('daochuchanpinguanxi') }}
        </el-button>

        <el-button size="mini" v-if="utils.checkPower('web_base_mould_insert_import')" plain @click="yt.showEditDialog('daorumujuxiangjianguanxi', null, 'w2')">
          {{ $t('daorumujuxiangjianguanxi') }}
        </el-button>
        <!-- 导入当前镶件 -->
        <el-button size="mini" v-if="utils.checkPower('web_base_mould_current_insert_import')" @click="yt.showEditDialog('daorudangqianxiangjian', null, '900px')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具台账-导入当前镶件' } }">
          {{ $t('daorudangqianxiangjian') }}
        </el-button>
        <!-- 吨位日志 -->
        <el-button size="mini" v-if="utils.checkPower('web_base_mould_tonnage_change_log')" @click="yt.showEditDialog('dunweirizhi', null, '900px')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具台账-吨位日志' } }">
          {{ $t('dunweirizhi') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" :loading="yt.editObj.loading" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_mould_mould_equipment_index')" @click="yt.showEditDialog('jimopei', scope.row, '70%')">{{ $t('jimopei') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_base_mould_update')"
              @click="
                yt.showEditDialog('bianji', scope.row);
                setDefaultValue();
              "
              >{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mouldNumberChangeLog', scope.row, '70%')">{{ $t('mouldNumberChangeLog') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mouldInOutRecord', scope.row, '70%')">{{ $t('mouldInOutRecord') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_base_mould_copy')"
              @click="
                yt.showEditDialog('fuzhi', scope.row);
                setIsCopyEquipmentMould();
                getCopyMouldNo(scope.row);
              "
            >
              {{ $t('fuzhi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_mould_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/mould/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
          <!-- 打印模具二维码 -->
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_base_mould_printMouldNo')" type="text" @click="printMouldNo(scope.row)">
              {{ $t('dayinmojuerweima') }}
            </el-button>
          </el-col>
          <!-- 镶件记录 -->
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_base_mould_insertChangeRecord')" type="text" @click="yt.showEditDialog('xiangjianjilu', scope.row, '1000px')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具台账-镶件记录' } }">
              {{ $t('xiangjianjilu') }}
            </el-button>
          </el-col>
          <!-- 详情 -->
          <el-col :span="0.1" v-if="utils.checkPower('web_base_mould_detail')">
            <el-button type="text" @click="yt.showEditDialog('xiangqing', scope.row, '70%', beforeOpenDetail)">{{ $t('xiangqing') }}</el-button>
          </el-col>
        </el-row>
      </template>
      <template #chang*kuan*gao(CM)="scope">
        {{ ((scope.row.length / 10).toFixed(1) % 1 == 0 ? (scope.row.length / 10).toFixed(0) : (scope.row.length / 10).toFixed(1)) + '*' + ((scope.row.width / 10).toFixed(1) % 1 == 0 ? (scope.row.width / 10).toFixed(0) : (scope.row.width / 10).toFixed(1)) + '*' + ((scope.row.heigth / 10).toFixed(1) % 1 == 0 ? (scope.row.heigth / 10).toFixed(0) : (scope.row.heigth / 10).toFixed(1)) }}
      </template>
      <template #zhongliang(KG)="scope">
        {{ (scope.row.weight != null ? (scope.row.weight / 1000).toFixed(1) : '') % 1 == 0 ? (scope.row.weight != null ? (scope.row.weight / 1000).toFixed(0) : '') : scope.row.weight != null ? (scope.row.weight / 1000).toFixed(1) : '' }}
      </template>
      <template #shifouzhumo="scope">
        {{ scope.row.isDominantMode ? $t('shi') : $t('fou') }}
      </template>

      <template #shifouchanqianbaoyang="scope">
        {{ scope.row.isPrepareMaintain ? $t('shi') : $t('fou') }}
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @close="handleClose">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('mujubianhao')" required>
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujubianma')" required>
              <el-input v-model="yt.editObj.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mojumingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhizaoshang')">
              <el-input v-model="yt.editObj.manufacturer"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhizaoriqi')">
              <yi_time_input type="date" format="yyyy-MM-dd" :time.sync="yt.editObj.manufactureDate"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('mujushouming')">
              <yi_number_input :start.sync="yt.editObj.lifetime" :precision="0" :min="0" :type="'number'"></yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('earlyUsedLifetime')">
              <yi_number_input :start.sync="yt.editObj.earlyUsedLifetime" :precision="0" :min="0" :type="'number'"></yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('mujuweizhi')">
              <el-input v-model="yt.editObj.location"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chang(CM)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.length" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('kuan(CM)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.width" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('gao(CM)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.heigth" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('zhongliang(KG)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.weight" :convert="'g-kg'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('zongmuqiangshu')" label-width="145px">
              <el-input-number v-model="yt.editObj.totalCavity" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('xiangmuhao')">
              <el-input v-model="yt.editObj.projectNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujuzhuangtai')" required="required">
              <yi_dictionary_select :type="'BASIC_MOULD_STATUS'" :ids.sync="yt.editObj.status"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('shifouzhumo')" required>
              <el-select v-model="yt.editObj.isDominantMode" @change="$forceUpdate()">
                <el-option :value="true" :label="$t('shi')"></el-option>
                <el-option :value="false" :label="$t('fou')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifouchanqianbaoyang')" required>
              <el-select v-model="yt.editObj.isPrepareMaintain" @change="$forceUpdate()">
                <el-option :value="true" :label="$t('shi')"></el-option>
                <el-option :value="false" :label="$t('fou')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('biaozhunrenli')">
              <el-input-number :min="0" v-model="yt.editObj.standardHumanResources"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/mould/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('mujubianhao')" required="required">
              <el-input v-model="yt.editObj.no" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujubianma')" required="required">
              <el-input v-model="yt.editObj.code" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujumingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhizaoshang')">
              <el-input v-model="yt.editObj.manufacturer"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhizaoriqi')">
              <yi_time_input type="date" format="yyyy-MM-dd" :time.sync="yt.editObj.manufactureDate"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('mujushouming')">
              <yi_number_input :start.sync="yt.editObj.lifetime" :precision="0" :min="0" :type="'number'"></yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('earlyUsedLifetime')">
              <yi_number_input :start.sync="yt.editObj.earlyUsedLifetime" :precision="0" :min="0" :type="'number'"></yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('mujuweizhi')">
              <el-input v-model="yt.editObj.location"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chang(CM)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.length" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('kuan(CM)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.width" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('gao(CM)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.heigth" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('zhongliang(KG)')">
              <yi_number_input :precision="1" :start.sync="yt.editObj.weight" :convert="'g-kg'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('zongmuqiangshu')" label-width="145px">
              <el-input-number v-model="yt.editObj.totalCavity" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('xiangmuhao')">
              <el-input v-model="yt.editObj.projectNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujuzhuangtai')" required="required">
              <yi_dictionary_select :type="'BASIC_MOULD_STATUS'" :ids.sync="yt.editObj.status"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('shifouzhumo')" required>
              <el-select v-model="yt.editObj.isDominantMode" @change="$forceUpdate()">
                <el-option :value="true" :label="$t('shi')"></el-option>
                <el-option :value="false" :label="$t('fou')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifouchanqianbaoyang')" required>
              <el-select v-model="yt.editObj.isPrepareMaintain" @change="$forceUpdate()">
                <el-option :value="true" :label="$t('shi')"></el-option>
                <el-option :value="false" :label="$t('fou')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('biaozhunrenli')">
              <el-input-number :min="0" v-model="yt.editObj.standardHumanResources"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/mould/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 复制表单 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('mujubianhao')" required>
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujubianma')" required>
              <el-input v-model="yt.editObj.code" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujumingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhizaoshang')">
              <el-input v-model="yt.editObj.manufacturer"></el-input>
            </el-form-item>

            <el-form-item :label="$t('zhizaoriqi')">
              <yi_time_input type="date" format="yyyy-MM-dd" :time.sync="yt.editObj.manufactureDate"></yi_time_input>
            </el-form-item>

            <el-form-item :label="$t('mujushouming')">
              <yi_number_input :start.sync="yt.editObj.lifetime" :precision="0" :min="0" :type="'number'"></yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('earlyUsedLifetime')">
              <yi_number_input :start.sync="yt.editObj.earlyUsedLifetime" :precision="0" :min="0" :type="'number'"></yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('mujuweizhi')">
              <el-input v-model="yt.editObj.location"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chang(CM)')">
              <yi_number_input :start.sync="yt.editObj.length" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('kuan(CM)')">
              <yi_number_input :start.sync="yt.editObj.width" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('gao(CM)')">
              <yi_number_input :start.sync="yt.editObj.heigth" :convert="'mm-cm'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('zhongliang(KG)')">
              <yi_number_input :start.sync="yt.editObj.weight" :convert="'g-kg'" :type="'number'"> </yi_number_input>
            </el-form-item>
            <el-form-item :label="$t('xiangmuhao')">
              <el-input v-model="yt.editObj.projectNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mujuzhuangtai')" required="required">
              <yi_dictionary_select :type="'BASIC_MOULD_STATUS'" :ids.sync="yt.editObj.status"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('shifoufuzhijimopei')" required="required">
              <el-select @change="$forceUpdate()" filterable v-model="yt.editObj.isCopyEquipmentMould" size="mini">
                <el-option :value="true" :label="$t('shi')"></el-option>
                <el-option :value="false" :label="$t('fou')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifouzhumo')" required>
              <el-select v-model="yt.editObj.isDominantMode" @change="$forceUpdate()">
                <el-option :value="true" :label="$t('shi')"></el-option>
                <el-option :value="false" :label="$t('fou')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifouchanqianbaoyang')" required>
              <el-select v-model="yt.editObj.isPrepareMaintain" @change="$forceUpdate()">
                <el-option :value="true" :label="$t('shi')"></el-option>
                <el-option :value="false" :label="$t('fou')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/mould/copy', beforeCopy)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 机模配 -->
      <template v-if="yt.editObj.action == 'jimopei'">
        <div class="dialog-scroller">
          <mould_equipment_index :mouldEquipment="yt.editObj"></mould_equipment_index>
        </div>
      </template>
      <!-- 模腔数修改记录 -->
      <template v-if="yt.editObj.action == 'mouldNumberChangeLog'">
        <div class="dialog-scroller">
          <mould_number_change_record :mouldEquipment="yt.editObj"></mould_number_change_record>
        </div>
      </template>
      <!-- 模具出入库记录 -->
      <template v-if="yt.editObj.action == 'mouldInOutRecord'">
        <div class="dialog-scroller">
          <mould_in_out_record :mouldEquipment="yt.editObj"></mould_in_out_record>
        </div>
      </template>

      <template v-if="yt.editObj.action == 'daorumujuxiangjianguanxi'">
        <div class="dialog-scroller">
          <yi_excel_import @loading-start="startLoading" @loading-stop="stopLoading" ref="mouldInsertImportTemplate" :templatekey="'mould_insert_import_template_key'" :uploadApi="'/web/basic/mould/mold/insert/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :disabled="importLoading" @click="mouldInsertImportData" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '镶嵌件关系-导入' } }">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <!-- 导入当前镶件 -->
      <template v-if="yt.editObj.action == 'daorudangqianxiangjian'">
        <div class="dialog-scroller">
          <yi_excel_import ref="currentInsertImport" @loading-start="currentInsertLoading = true" @loading-stop="currentInsertLoading = false" :templatekey="'current_insert_template_key'" :uploadApi="'/web/mold/insert/change/record/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="currentInsertLoading" @click="currentInsertImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <!-- 吨位日志 -->
      <template v-if="yt.editObj.action == 'dunweirizhi'">
        <div class="dialog-scroller">
          <mould_tonnage_change_log :mouldEquipment="yt.editObj"></mould_tonnage_change_log>
        </div>
      </template>
      <!-- 镶件记录 -->
      <template v-if="yt.editObj.action == 'xiangjianjilu'">
        <div class="dialog-scroller">
          <insert_change_record :mold="yt.editObj"></insert_change_record>
        </div>
      </template>
      <!-- 详情 -->
      <template v-if="yt.editObj.action === 'xiangqing'">
        <div class="detail-container">
          <div>
            <div>{{ $t('mujubianhao') }}：{{ yt.editObj.no }}</div>
            <div>{{ $t('mujumingcheng') }}：{{ yt.editObj.name }}</div>
          </div>
          <div style="padding-top: 10px;">
            <el-form :inline="true" :model="detailForm" label-position="right" :rules="detailFormRules" ref="ruleDetailForm">
              <div class="title">{{ $t('jibenxinxi') }}</div>
              <el-form-item :label="$t('mojuleibie')">
                <yi_dictionary_select type="MOULD_CATEGORY" :ids.sync="detailForm.mouldCategory"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('zongmuqiangshu')">
                <el-input-number v-model="detailForm.totalCavity" controls-position="right" size="mini" :min="1"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('zhusuzhouqiyaoqiu(miao)')">
                <el-input-number v-model="detailForm.injectCycleRequire" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
              <div class="title">{{ $t('zhipinxinxi') }}</div>
              <el-form-item :label="$t('chanpinleibie')">
                <yi_dictionary_select type="PRODUCT_CATEGORY" :ids.sync="detailForm.productCategory"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('zhipinmingcheng')">
                <el-input v-model="detailForm.productName" :maxlength="200" size="mini"></el-input>
              </el-form-item>
              <el-form-item :label="$t('zongzhongliang') + '(g)'">
                <el-input-number v-model="detailForm.totalWeight" controls-position="right" size="mini" :precision="3" :min="0"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('zhipinliuchang') + '(mm)'">
                <el-input-number v-model="detailForm.productFlowLength" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('zuidabihou') + '(mm)'">
                <el-input-number v-model="detailForm.maxWallThickness" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('pingjunbihou') + '(mm)'">
                <el-input-number v-model="detailForm.averageWallThickness" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
              <div class="title">{{ $t('jiaozhuxitong') }}</div>
              <el-form-item :label="$t('liudaoleibie')">
                <yi_dictionary_select type="CHANNEL_CATEGORY" :ids.sync="detailForm.channelCategory"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('reliudaoduanshu')" :required="detailForm.channelCategory === '1'" prop="hotRunnerSegments">
                <el-input-number v-model="detailForm.hotRunnerSegments" controls-position="right" size="mini" :min="1" :max="36"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('liudaochangdu') + '(mm)'">
                <el-input-number v-model="detailForm.channelLength" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('liudaozhongliang') + '(g)'">
                <el-input-number v-model="detailForm.channelWeight" controls-position="right" size="mini" :precision="3" :min="0"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('jiaokouleibie')">
                <yi_dictionary_select type="GATE_CATEGORY" :ids.sync="detailForm.gateCategory"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('jiaokoushuliang')">
                <el-input-number v-model="detailForm.gateNumber" controls-position="right" size="mini" :min="0"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('jiaokouxingzhuang')">
                <yi_dictionary_select type="GATE_SHAPE" :ids.sync="detailForm.gateShape"> </yi_dictionary_select>
              </el-form-item>
              <div class="title-blue">{{ $t('jiaokouxingzhuangweiyuanxing') }}</div>
              <el-form-item :label="$t('jiaokoubanjing') + '(mm)'">
                <el-input-number v-model="detailForm.gateRadius" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
              <div class="title-blue">{{ $t('jiaokouxingzhuangweijuxing') }}</div>
              <el-form-item :label="$t('jiaokouchang') + '(mm)'">
                <el-input-number v-model="detailForm.gateLength" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('jiaokoukuan') + '(mm)'">
                <el-input-number v-model="detailForm.gateWidth" controls-position="right" size="mini" :precision="1" :min="0"></el-input-number>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" type="primary" @click="detailSave" :loading="detailSaveLoading">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <import_excel :show.sync="show" />
    <production_import_excel :productionShow.sync="productionShow" />
    <eq_relationship_import_excel :equipmentShow.sync="equipmentShow" />
    <eq_tonnage_import_excel :tonnageShow.sync="tonnageShow" />
    <el-dialog :title="$t('daoruzhufuchanpin')" :visible.sync="mainSubProductShow" width="900px" append-to-body="append-to-body" :before-close="closeMainSubProductDialog">
      <div class="dialog-scroller">
        <yi_excel_import ref="mainSubExcelImport" :templatekey="'main_sub_product_import'" :uploadApi="'/web/basic/mouldEquipment/batch/createByMatchNumber'" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="closeMainSubProductDialog">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
    <!-- 打印模具二维码 -->
    <el-dialog :show-close="true" :visible.sync="isShowPrintDialog" width="400px" append-to-body="append-to-body" :before-close="closePrintDialog">
      <div v-if="isShowPrintDialog" style="height: 350px;width: 330px;margin-top: 15px">
        <div style="margin-top: 5px" :style="{ width: getDpi(90) + 'px', height: getDpi(90) + 'px' }" class="printFontFamily">
          <div id="printContent" style="text-align: center;">
            <vue-qr :text="printObj.no" :margin="0" :size="250"></vue-qr>
            <div style="margin-top: 10px;font-size: 22px;color: black;">{{ printObj.no }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" style="display: block;text-align: center;">
        <div>
          <el-button @click="isShowPrintDialog = false" style="width: 130px;">{{ $t('quxiao') }}</el-button>
          <el-button @click="dayin()" type="primary" style="width: 130px">{{ $t('dayin') }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Bury from '@/common/bury.js';
import mould_equipment from '@@/pages/web/base/mould/mould_equipment';
import production_import_excel from '@@/pages/web/base/mould/import/production_import_excel';
import eq_relationship_import_excel from '@@/pages/web/base/mould/import/eq_relationship_import_excel';
import eq_tonnage_import_excel from '@@/pages/web/base/mould/import/eq_tonnage_import_excel';
import import_excel from '@@/pages/web/base/mould/import/import_excel';
import mould_equipment_index from '@@/pages/web/base/mould/mould_equipment_index';
import mould_number_change_record from '@@/pages/web/base/mould/mould_number_change_record';
import mould_in_out_record from '@@/pages/web/base/mould/mould_in_out_record';
import insert_change_record from '@@/pages/web/base/mould/insert_change_record';
import mould_tonnage_change_log from '@@/pages/web/base/mould/mould_tonage_change_log';
import VueQr from 'vue-qr';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export default {
  components: {
    mould_equipment,
    import_excel,
    production_import_excel,
    eq_relationship_import_excel,
    eq_tonnage_import_excel,
    mould_equipment_index,
    mould_number_change_record,
    mould_in_out_record,
    insert_change_record,
    VueQr,
    mould_tonnage_change_log
  },
  /* 唯一命名 */
  name: 'web_base_mould_list',
  data() {
    // 详情里的热流道段数字段验证器
    const validateHotRunnerSegments = (rule, value, callback) => {
      if (this.detailForm.channelCategory === '1' && !value) {
        callback(new Error(this.$t('ziduanbitian')));
      } else {
        callback();
      }
    };

    return {
      show: false,
      productionShow: false,
      equipmentShow: false,
      tonnageShow: false,
      mainSubProductShow: false,
      mainSubImportLoading: false,
      organizationList: [],
      mouldProductList: [],
      printObj: {},
      isShowPrintDialog: false,
      isPrint: false,
      blobs: [],
      importLoading: false,
      currentInsertLoading: false,
      detailForm: {},
      detailSaveLoading: false,
      detailFormRules: {
        hotRunnerSegments: [{ validator: validateHotRunnerSegments, trigger: 'blur' }]
      },
      columns: [
        {
          label: 'mujubianhao',
          prop: 'no',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujubianma',
          prop: 'code',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'name',
          sort: 'string'
          // width: 130
        },
        {
          label: 'zhizaoshang',
          prop: 'manufacturer'
        },
        {
          label: 'zhizaoriqi',
          prop: 'manufactureDate',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'mujushouming',
          prop: 'lifetime',
          width: 100
        },
        {
          label: 'earlyUsedLifetime',
          prop: 'earlyUsedLifetime',
          width: 100
        },
        {
          label: 'mujuweizhi',
          prop: 'location'
        },
        {
          label: 'chang*kuan*gao(CM)',
          type: 'slot'
        },
        {
          label: 'zhongliang(KG)',
          type: 'slot'
        },
        {
          label: 'zongmuqiangshu',
          prop: 'totalCavity',
          width: 130
        },
        {
          label: 'xiangmuhao',
          prop: 'projectNo'
        },
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'BASIC_MOULD_STATUS'
        },
        {
          label: 'shifouzhumo',
          type: 'slot'
        },
        {
          label: 'chuangjianshijian',
          type: 'time',
          prop: 'createTime',
          width: 130
        },
        {
          label: 'shifouchanqianbaoyang',
          type: 'slot'
        },
        {
          label: 'dangqianxiangjianbianma',
          prop: 'moldInsert.code'
        },
        {
          label: 'dangqianxiangjianmingcheng',
          prop: 'moldInsert.name'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 280,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.utils.event_hub.$on('BASE_MOULD_LIST_REFRESH', () => {
        this.yt.get();
      });
      this.yt.SELECT_URL = '/web/basic/mould/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.get(1);
      this.utils.event_hub.$on('EQUIPMENT_MOULD_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  destroyed() {
    this.utils.event_hub.$off('BASE_MOULD_LIST_REFRESH');
    this.utils.event_hub.$off('EQUIPMENT_MOULD_REFRESH');
  },
  methods: {
    // 详情保存
    detailSave() {
      this.$refs['ruleDetailForm'].validate(valid => {
        if (valid) {
          const detailJson = JSON.stringify(this.detailForm);
          const data = {
            basicMouldId: this.yt.editObj.id,
            detailJson: detailJson
          };
          this.detailSaveLoading = true;
          // 保存或更新
          Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具台账-详情-保存' } });
          this.http
            .post('/web/basic/mould/detail/saveOrUpdate', data)
            .then(res => {
              this.$message.success(this.$t(res.msg));
              this.yt.isShowEditDialog = false;
              this.yt.get();
            })
            .catch(err => {
              this.$message.error(this.$t(err));
            })
            .finally(() => {
              this.detailSaveLoading = false;
            });
        }
      });
    },
    // 打开详情之前的处理
    beforeOpenDetail(params) {
      this.getDetail(params.id);
      return params;
    },
    // 获取详情
    getDetail(mouldId) {
      this.http
        .get('/web/basic/mould/detail/getByMouldId?basicMouldId=' + mouldId)
        .then(res => {
          const data = res.data;
          if (data && data.detailJson) {
            this.detailForm = JSON.parse(data.detailJson);
          } else {
            this.detailForm.totalCavity = this.yt.editObj.totalCavity;
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 对话框关闭时
    handleClose() {
      if (this.yt.editObj.action === 'xiangqing') {
        this.detailForm = {};
      }
    },
    startLoading() {
      this.importLoading = true;
    },
    stopLoading() {
      this.importLoading = false;
    },
    mouldInsertImportData() {
      let data = [...this.$refs.mouldInsertImportTemplate.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.mouldInsertImportTemplate.listLength == null || this.$refs.mouldInsertImportTemplate.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/basic/mould/mold/insert/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },

    setDefaultValue() {
      if (this.yt.editObj.action === 'xinzeng') {
        this.yt.editObj.isDominantMode = true;
        this.yt.editObj.isPrepareMaintain = false;
        this.yt.editObj.totalCavity = 0;
        this.yt.editObj.status = '1';
      }
      if (this.yt.editObj.action === 'bianji' && (this.yt.editObj.totalCavity == null || yt.editObj.totalCavity == undefined)) {
        this.yt.editObj.totalCavity = 0;
      }
    },
    exportExcel() {
      // delete this.yt.conditions.orderBy
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/export/basic_mould_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    exportExcel2() {
      // delete this.yt.conditions.orderBy

      console.log('kkkk', this.yt.conditions);
      let params = this.yt.conditions;
      this.$set(params, 'orderBy', 'no asc');
      console.log('params:', params);
      return this.http
        .get('/web/report/export/basic_mould_prodcution_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    submitEquipmentStanding() {
      let data = this.$refs.equipmentStanding.$refs.yt.list;
      let sns = data.map(item => {
        return item.sn;
      });

      this.http
        .post('web/equipment/standing_book/equipmentOrgUpdate', {
          sns
        })
        .then(res => {
          console.log('wwwww', res.sns);
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        });
    },
    setIsCopyEquipmentMould() {
      this.yt.editObj.isDominantMode = false;
      this.yt.editObj.isCopyEquipmentMould = true;
    },
    beforeCopy(params) {
      //先声明一个数组对象
      let basicMouldVO = params;
      let jsonParams = {
        isCopyEquipmentMould: params.isCopyEquipmentMould,
        basicMouldVO: params,
        isDominantMode: this.yt.editObj.isDominantMode
      };
      return jsonParams;
    },
    // 处理复制时的模具编号,在模具编号后+01,如果01已存在就递增
    async getCopyMouldNo(params) {
      let response = await this.http.get('/web/basic/mould/getNo?mouldId=' + params.id);
      this.yt.editObj.no = response.data;
    },
    mainSubImportData() {
      let data = [...this.$refs.mainSubExcelImport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.mainSubExcelImport.listLength == null || this.$refs.mainSubExcelImport.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/basic/mouldEquipment/batch/createByMatchNumber?onlyValidate=false', this.$refs.mainSubExcelImport.tableData)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.closeMainSubProductDialog();
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    closeMainSubProductDialog() {
      this.$refs.mainSubExcelImport.listLength = null;
      this.$refs.mainSubExcelImport.tableData = [];
      this.$refs.mainSubExcelImport.excel = [];
      this.$refs.mainSubExcelImport.pagination.currentPage = 1;
      this.$refs.mainSubExcelImport.$refs['excel-upload-input'].value = null;
      this.mainSubProductShow = false;
    },
    currentInsertImportData() {
      let data = [...this.$refs.currentInsertImport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.currentInsertImport.listLength == null || this.$refs.currentInsertImport.listLength.length == 0) {
        this.currentInsertLoading = true;
        this.http
          .post('/web/mold/insert/change/record/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get();
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.currentInsertLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    printMouldNo(row) {
      this.printObj = this.utils.copy(row);
      this.isPrint = false;
      this.isShowPrintDialog = true;
    },
    getDpi(num) {
      const inch = document.createElement('div');
      inch.style.width = '1in';
      document.body.appendChild(inch);
      const dpi = inch.offsetWidth;
      document.body.removeChild(inch);
      const unit = Number(num);
      const inchs = unit / 25.4;
      const px = inchs * dpi;
      return Math.round(px);
    },
    closePrintDialog() {
      this.isShowPrintDialog = false;
    },
    dayin() {
      let targetDom = document.getElementById('printContent'); //你的目标元素id
      let copyDom = targetDom.cloneNode(true); // 克隆节点
      copyDom.style.width = targetDom.offsetWidth + 'px';
      copyDom.style.height = targetDom.scrollHeight + 'PX'; // 获得高度
      document.body.appendChild(copyDom); // 插入节点

      html2canvas(copyDom).then(canvas => {
        document.body.removeChild(copyDom); // 删除节点
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let imgWidth = contentWidth;
        let imgHeight = contentHeight;
        let pageData = canvas.toDataURL('image/jpeg', 1.0);
        //第一个参数： l：横向  p：纵向;第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）;第三个参数：可以是下面格式，默认为“a4”
        let pdf = new jsPDF('l', 'px', [imgWidth, imgHeight]);
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        let pdf64 = pdf.output('blob');
        this.blobs.push(pdf64);
        this.sends();
      });
    },
    sends() {
      const formData = new FormData();
      for (let index = 0; index < this.blobs.length; index++) {
        formData.append('files[]', this.blobs[index]);
        formData.append('isVertical', 'true'); //不需要旋转图片
      }
      this.printLoading = true;
      this.http
        .post('http://127.0.0.1:9090/printLocalPDF', formData, {
          headers: {
            'Content-Type': 'multipart/form-data' // 设置请求头，确保服务器正确解析 FormData
          }
        })
        .then(res => {
          console.log(res);
          this.$message.success(this.$t('chenggong'));
        })
        .finally(() => {
          this.printLoading = false;
          this.isShowPrintDialog = false;
        });
      this.blobs = [];
    }
  }
};
</script>
